export interface Role {
  id: number;
  nome: string;
  descricao?: string;
}

export enum RoleType {
  SUPERADMIN = "Superadmin",
  ADMINISTRADOR = "Administrador",
  RESPONSAVEL_TECNICO = "Responsável Técnico",
  USUARIO = "Usuário",
  PARCEIRO = "Parceiro",
}

export interface newUser {
  id?: number;
  nome: string;
  email: string;
  provedor: string;
  confirmarEmail: string;
  confirmarProvedor: string;
  tipo: string;
  cpf: string;
  senha: string;
  confirmarSenha: string;
  force_password_change?: boolean;
}

export interface Permission {
  id: number;
  role_id: number;
  page_id: number;
  descricao?: string;
}

export interface User {
  id?: number;
  nome: string;
  nome_social?: string;
  email: string;
  token: string;
  role: string;
  role_id?: number;
  cpf: string;
  permissions: string[];
  action_permissions?: string[];
  active_role?: Role;
  base_role?: Role;
  switchable_roles?: Role[];
  force_password_change?: boolean;
}

export interface AuthResponse {
  id?: number;
  user_id?: number;
  token: string;
  role: string;
  role_id: number;
  name?: string;
  nome?: string;
  nome_social?: string;
  email: string;
  permissions: string[];
  action_permissions?: string[];
  active_role?: Role;
  base_role?: Role;
  switchable_roles?: Role[];
  force_password_change?: boolean;
}

export interface BaseUsuario {
  id: string;
  nome: string;
  possui_nome_social?: boolean;
  nome_social?: string;
  email: string;
  role: string;
  ativo: boolean;
  cpf: string;
  ambito: string;
  lotacao: string;
  municipio: string;
  last_login_at?: string | null;
  last_access_at?: string | null;
  created_at?: string | null;
}

export interface Course {
  id: number;
  nome: string;
  descricao?: string;
  tipo_id: number;
  modalidade_id: number;
  polo_id?: number;
  carga_horaria?: number;
  vagas?: number;
  responsavel_id: number;
  status: CourseStatus;
  data_inicio?: Date;
  data_fim?: Date;
}

export enum CourseStatus {
  ABERTO = "Aberto",
  ENCERRADO = "Encerrado",
  EM_ANDAMENTO = "Em andamento",
  CANCELADO = "Cancelado",
}

export interface RegionalPolo {
  id: number;
  nome: string;
  estado?: string;
  cidade?: string;
}

export interface Enrollment {
  id: number;
  user_id: number;
  course_id: number;
  presenca: number;
  status: EnrollmentStatus;
  nota_final?: number;
  data_inscricao?: Date;
  data_aprovacao?: Date;
}

export enum EnrollmentStatus {
  INSCRITO = "Inscrito",
  APROVADO = "Aprovado",
  REPROVADO = "Reprovado",
}

export interface Certificate {
  id: number;
  codigo: string;
  user_id: number;
  course_id: number;
  tipo: CertificateType;
  data_emissao?: Date;
  arquivo_url?: string;
}

export enum CertificateType {
  CERTIFICADO = "Certificado",
  DECLARACAO = "Declaração",
}

export interface Institution {
  id: number;
  nome: string;
  tipo: InstitutionType;
  contato?: string;
}

export enum InstitutionType {
  UNIVERSIDADE = "Universidade",
  ONG = "ONG",
  GOVERNO = "Governo",
  OUTROS = "Outros",
}

export interface ContactDetail {
  telefone_residencial?: string;
  telefone_celular?: string;
  possui_whatsapp: boolean;
  telefone_institucional?: string;
  email_institucional?: string;
}

export interface AddressDetail {
  cep: string;
  logradouro: string;
  numero: string;
  complemento?: string;
  bairro: string;
  cidade: string;
  uf: string;
}

export interface PersonalData {
  rg: string;
  emissor: string;
  uf: string;
  identidade_genero: GenderIdentity | undefined;
  identidade_genero_outros?: string;
  cor_raca?: string;
  data_nascimento: Date | undefined | string;
  escolaridade: EducationLevel | undefined;
  profissao: string;
  profissao_outros?: string;
  possui_nome_social: boolean;
  possui_deficiencia: boolean;
  deficiencia_outros?: string;
  nome_social?: string;
  estrutura_participacao?: string;
}

export enum GenderIdentity {
  SELECIONE = "",
  MULHER = "Mulher Cis",
  MULHER_TRANS = "Mulher Trans",
  HOMEM = "Homem Cis",
  HOMEM_TRANS = "Homem Trans",
  NAO_BINARIO = "Não Binário",
  OUTRO = "Outro",
}

export enum EducationLevel {
  FUNDAMENTAL = "Fundamental",
  MEDIO = "Médio",
  TECNICO = "Técnico",
  SUPERIOR = "Superior",
  ESPECIALIZACAO = "Especialização",
  MESTRADO = "Mestrado",
  DOUTORADO = "Doutorado",
}

export interface ProfessionalData {
  ambito_id: number | "";
  municipio_id?: number | "";
  lotacao_id?: number | "";
  vinculo_id?: number | "";
  funcao_id?: number | "";
  superintendencia_id?: number | "";
  unidade_id?: number | "";
  diretoria_regional_id?: number | "";
  diretoria_interna_id?: number | "";
  orgao_atuacao_id?: number | "";
  instituicao_id?: number | "";

  // Campos legados para compatibilidade de telas que ainda exibem descrições.
  ambito?: string;
  municipio?: string;
  lotacao?: string;
  vinculo_empregaticio?: string;
  funcao_desempenhada?: string;
  superintendencia_assessoria?: string;
  unidade?: string;
  diretoria_reginal?: string;
  diretoria_interna?: string;
  orgao_atuacao?: string;
  instituicao?: string;
  updated_at?: string | null;
}

export interface Option {
  group: string;
  name: string;
}

export interface AreaActivity {
  area_id?: number;
  group: string;
  name: string;
}

export interface Disability {
  deficiencia: string;
}

export interface DataChange {
  usuario_alteracao_id?: number;
  tabela_editada: string;
  registro_id?: number;
  registro_nome?: string;
  campo_editado: string;
  valor_antigo?: string;
  valor_novo?: string;
  motivo_alteracao?: string;
  data_alteracao: Date;
}

export interface ValidadeUser {
  cpf: string,
  email: string,
  id?: number;
}

export interface ResponseValidateUser {
  exists: boolean;
  message: string;
  errors?: string[];
}

export interface UsuarioLotacao {
  id: number;
  nome: string;
  cpf: string;
  email: string;
  role_id: number;
  role: string;
  ativo: boolean;
  ambito_id: number;
  ambito: string;
  lotacao_id: number;
  lotacao: string;
  unidade_id: number | null;
  unidade_regional: string | null;
  diretoria_regional_id: number | null;
  diretoria_regional: string | null;
  superintendencia_id: number | null;
  superintendencia: string |null;
}

export interface UsuarioInstituicao  {
  id: number;
  nome: string;
  cpf: string;
  email: string;
  role_id: number;
  role: string;
  ativo: number;
  institution_id: number;
  institution: string;
  tipo: string;
}
